import React from 'react';
import { classes } from './constants';

type AnnouncementSectionProps = {
  id: string;
  title: string;
  children: React.ReactNode;
};

export function AnnouncementSection({
  id,
  title,
  children,
}: AnnouncementSectionProps): React.ReactElement {
  return (
    <div id={id} className={classes.section}>
      <div className="odin-bg-white odin-pt-5 sm:odin-pt-9">
        <div className="md:odin-grid md:odin-grid-cols-12 md:odin-gap-6">
          <div className={classes.fourspan}>
            <h3 className={classes.sectionHeader}>{title}</h3>
          </div>
          <div className={classes.children}>{children}</div>
        </div>
      </div>
    </div>
  );
}
